<template>
  <div>
    <div class="main-content main-content1 font1rem">
      <!-- one tab -->
      <div class="conatiner-fluid d1" id="DataA">
        <div class="row mt-3">
          <div class="col-lg-4 col-md-6 col-xl-3 col-sm-6 col-xs-12 pr-0 mb-3" data-aspect-ratio="4:3" v-for="(index,i) in filteredList" v-bind:key="index.projectid" v-if="index.status && i < projectsToShow">
            <div class="p-box" @click="redirectToPhotos(index)" :style="{ backgroundImage: 'url(\'' + getImgUrl(index) + '\')' }">
              <div class="box-text">
                <span class="bt1">{{ index.name }}</span>
                <span class="bt2">{{ index.city }} - {{index.startdate | setDateFormat}} </span>
                <hr/>
                <div class="bt-box">
                  <div>
                    <img class="img-responsive" src="@/assets/images/pictures.svg" alt="user" />
                    {{ $t('pictures') }}: {{ index.photocount }}
                  </div>
                  <div>
                    <img
                      class="img-responsive"
                      src="@/assets/images/tickets.svg"
                      alt="user"
                    />
                    {{ $t('tickets') }}: {{ index.flawcount }}
                  </div>
                  <br />
                  <div>
                    <img class="img-responsive" src="@/assets/images/plans.svg" alt="user"/>
                    {{ $t('plan') }}: {{ index.plancount }}
                  </div>
                  <div>
                    <img class="img-responsive" src="@/assets/images/reports.svg" alt="user" />
                    {{ $t('reports') }}: {{index.reportcount}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading" class="col-sm-12 text-center pr-0">
            <p class="mb-1">Weitere Projekte werden geladen…</p>
            <span class="spinner-border text-secondary"></span>
          </div>
        </div>
      </div>

      <!-- endtabone -->
<!--     <div class="conatiner-fluid d1"  id="DataB" style="display:none">-->
<!--        <div class="row">-->
<!--          <div-->
<!--            class="col-lg-3 col-md-6 col-sm-6 col-xs-12"-->
<!--            v-for="(index,i) in filteredList"-->
<!--            :key="index.projectid"-->
<!--            v-if="index.isfav"-->
<!--          >-->
<!--            <div class="p-box">-->
<!--              <img @click="redirectToPlan(index.id)" :src="index.src" alt="user" width="100%" />-->
<!--              <div class="uperHeart">-->
<!--                <div class="heart-pos" v-if="!index.isfav">-->
<!--                  <img-->
<!--                    @click="setFavProject(index.projectid)"-->
<!--                    class="img-responsive"-->
<!--                    src="@/assets/images/empty.png"-->
<!--                    alt="user"-->
<!--                  />-->
<!--                </div>-->
<!--                <div class="heart-pos" v-else>-->
<!--                  <img-->
<!--                    @click="delFavProject(index.projectid)"-->
<!--                    class="img-responsive"-->
<!--                    src="@/assets/images/heart.png"-->
<!--                    alt="user"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="box-text">-->
<!--                <span class="bt1">{{index.name}}</span>-->
<!--                <span class="bt2">{{index.city}}</span>-->
<!--                <hr />-->
<!--                <div class="bt-box">-->
<!--                  <div>-->
<!--                    <img class="img-responsive" src="@/assets/images/icons8-bild-96.png" alt="user" />-->
<!--                    {{ $t('pictures') }}: {{index.photocount}}-->
<!--                  </div>-->
<!--                  <div>-->
<!--                    <img-->
<!--                      class="img-responsive"-->
<!--                      src="@/assets/images/icons8-aufgabenliste-96.png"-->
<!--                      alt="user"-->
<!--                    />-->
<!--                    {{ $t('tickets') }}: {{index.reportcount}}-->
<!--                  </div>-->
<!--                  <br />-->
<!--                  <div>-->
<!--                    <img-->
<!--                      class="img-responsive"-->
<!--                      src="@/assets/images/icons8-bilddatei-96.png"-->
<!--                      alt="user"-->
<!--                    />-->
<!--                    {{ $t('plan') }}: {{index.plancount}}-->
<!--                  </div>-->
<!--                  <div>-->
<!--                    <img class="img-responsive" src="@/assets/images/icons8-bild-96.png" alt="user" />-->
<!--                    {{ $t('reports') }}: {{index.reportcount}}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

     <div class="conatiner-fluid d1"  id="DataC" style="display:none">
        <div class="row mt-3">
          <div
            class="col-lg-3 col-md-6 col-sm-6 col-xs-12 pr-0 mb-3"
            data-aspect-ratio="4:3"
            v-for="(index,i) in filteredArchiveList"
            :key="index.projectid"
            v-if="!index.status">
            <div class="p-box" @click="redirectToPhotos(index)" :style="{ backgroundImage: 'url(\'' + getImgUrl(index) + '\')' }">
              <div class="box-text">
                <span class="bt1">{{ index.name }}</span>
                <span class="bt2">{{ index.city }} - {{index.startdate | setDateFormat}}</span>
                <hr/>
                <div class="bt-box">
                  <div>
                    <img class="img-responsive" src="@/assets/images/pictures.svg" alt="user" />
                    {{ $t('pictures') }}: {{ index.photocount }}
                  </div>
                  <div>
                    <img
                      class="img-responsive"
                      src="@/assets/images/tickets.svg"
                      alt="user"
                    />
                    {{ $t('tickets') }}: {{ index.reportcount }}
                  </div>
                  <br />
                  <div>
                    <img class="img-responsive" src="@/assets/images/plans.svg" alt="user"/>
                    {{ $t('plan') }}: {{ index.plancount }}
                  </div>
                  <div>
                    <img class="img-responsive" src="@/assets/images/reports.svg" alt="user" />
                    {{ $t('reports') }}: {{index.reportcount}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end tab 3 -->
    </div>

    <!-- Modal 3-->
    <div
      class="modal fade"
      id="exampleModalCenter3"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true">
      <div class="response-alert">
        <div class="alert alert-success alert-dismissible" v-for="m in modal3">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong></strong>
          {{m}}
        </div>
        <div class="spinner-cover" style="display: block;">
          <div class="spinner"></div>
        </div>
        <div class="alert alert-danger alert-dismissible" v-for="e in emodal3">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <strong></strong>
          {{e}}
        </div>
      </div>
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content col-6" style="margin: 0 auto;">
          <form @submit.prevent="createProject()" id="project_form">
            <div class="modal-body">
              <div class="row row-data">
                <div class="col-12 pro-style">{{ $t("create_new_project") }} </div>

                <div class="col-lg-6 col-md-6 col-2nd">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>{{ $t("project_name") }} *</label>
                      <div class="input-group">
                        <input class="input--style-2"
                          type="text"
                          :placeholder="$t('project_name')"
                          v-model="project.name"
                          @blur="$v.project.name.$touch()"
                          :class="{ 'is-invalid':submitted &&$v.project.name.$error }"
                        />
                      </div>
                      <div v-if="submitted && !$v.project.name.required"
                        class="text-danger">{{ $t('project_name') }} {{ $t('is_required') }}
                      </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <label>{{ $t("location") }} *</label>
                      <div class="input-group">
                        <input class="input--style-2" required type="text" :placeholder="$t('location')" v-model="project.city"/>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="custom-control custom-checkbox mb-3 custom-check">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customCheck1"
                        true-value="1"
                        false-value="0"
                        @change="project.as_testproject === '1' ? project.customer_id = '0' : ''"
                        v-model="project.as_testproject"
                        :disabled="!canCreateTestProject()"
                      />
                      <label class="custom-control-label lb-dn" for="customCheck1">
                        {{ $t("create_as_test") }} / {{ $t("demo_project") }}
                      </label>
                      <template v-if="!canCreateTestProject()">
                        <p class="bg-warning">Sie verfügen bereits über ein Testprojekt.</p>
                      </template>
                    </div>
                  </div>

                  <div class="row select-box d-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div class="form-group">
                        <select class="custom-select font1rem form-control custom-select-sm mb-3" v-model="project.src_project">
                          <option value="0" selected>{{ $t("empty_project") }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-3rd">
                  <div class="textare-lable">{{ $t("select_customer") }}</div>
                  <div class="form-group">
                     <select class="cus-select1 form-control font1rem" v-model="project.customer_id"  :disabled="project.as_testproject === '1'" :required="project.as_testproject === '0'">
                      <option v-for="cc in customerCreateProject" :value="cc.customer_id"> {{cc.company_name}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer mf-1st">
              <button type="submit" class="btn btn-primary mode-s">
                {{ $t("create_project") }}
              </button>
              <div class="cross-close" data-dismiss="modal">
                <img src="@/assets/images/cross.png" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal3 -->
    <div class="response-alert">
      <div class="alert alert-success alert-dismissible" v-for="m in msg">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong></strong>
        {{m}}
      </div>
      <div class="alert alert-danger alert-dismissible" v-for="e in error">
        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
        <strong></strong>
        {{e}}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {required} from 'vuelidate/lib/validators'
import {todayDate,formatDate} from '../common'
// Fixed by merge 10112020-0247
export default {
  name: 'HelloWorld',
  data() {
    return {
      loading: false,
      submitted: false,
      projectsToShow : 24,
      projectsPerView : 4,
      btnMore : false,
      allProjects : [],
      projects: [
        {
          id: "",
          projectname: "",
          name: "",
          shortname: "",
          projectnumber: "",
          street: " ",
          zipcode: " ",
          city: " ",
          country: "",
          constructor: "",
          manager: "",
          description: "",
          startdate: "",
          enddate: "",
          status: "",
          creator_id: "",
          logo1_id: "",
          logo2_id: "",
          decoimage_id: "",
          decoimage: "",
          customer_id: '0',
          curphoto_count: "",
          curticket_count: "",
          curplan_count: "",
          currentreport_count: "",
          project_last_change: "",
          deleted: "",
          cr_date: "",
          ch_date: "",
          details: [],
          pd_customer: {
            customer_id: "0",
            customer_number: "",
            company_name: "",
            company_name_department: "",
            adress: "",
            adress2: null,
            zipcode: "",
            city: "",
            country: "",
            contactperson_u_id: null,
            gender: "",
            title: null,
            firstname: "",
            lastname: "",
            phone1: "",
            phone2: "",
            information: null,
            date_create: "",
            date_edit: ""
          },
          isFav: 0
        }
      ],
      favourites: [],
      customerCreateProject: [],
      customerTestProject: [],
      customerAdmin: [],
      tabA: 1,
      tabC: 0,
      tabB: 0,
      search: "",
      Isarchive: 1,
      msg: [],
      error: [],
      src: "0",
      images: [],
      modal3: [],
      emodal3: [],
      count : 1,

      activeprojects: [],
      archiveprojects: []
    };
  },
  validations: {
    project: {
      name: { required },
    },
  },

  filters: {
    setDateFormat: (d) => formatDate(d)
  },
  mounted () {
    // Benjamin: neet to be replaced for old system
    // this.getfevProject()
    this.getCustomerList();
    this.$store.commit('setSearchStringEmpty')
    let obj = this
    setTimeout(function () { obj.btnMore = true }, 500);
    window.onscroll = function(ev) {
      if (!obj.loading && ((window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 65))) {
        if (obj.btnMore){
          obj.loadMore();
        }
      }
    };
  },

  created () {
    this.getProject();
  },

  methods: {

    getImgUrl(tempProject) {
      return process.env.VUE_APP_GET_METHOD_URL + "deco&projectid=" + tempProject.projectid + "&id=" + tempProject.decoimage + `&token=` + localStorage.sessiontoken + `&PHPSESSID=` + localStorage.sessiontoken
    },
    canCreateTestProject () {
      if(this.customerTestProject.authorizationActionCode !== undefined && this.customerTestProject.authorizationActionCode == 1) {
        console.log('ProjectAlreadyExists')
        return true
      }

      return false

    },


    async getProject () {
      const parameters = [];
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
          parameters: parameters,
          serviceName: "ProjectdocuService",
          methodName: "getProjects"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: "application/json"
          }
        }).then(response => {
          this.projects = response.data.reverse();
          this.$store.commit('setProjects', this.projects)
          let tempactive = []
          let temparchive = []
          this.projects.forEach(project => {
            if(project.status == 1) {
              tempactive.push(project)
            } else {
              temparchive.push(project)
            }
          });

          this.archiveprojects = temparchive
          this.activeprojects = tempactive

          this.$store.commit('setActiveProjects', this.activeprojects)
          this.$store.commit('setArchiveProjects', this.archiveprojects)
          setTimeout(function () {  $('.spinner-cover').hide() }, 1000)
        }).catch(e => {console.log(e)})
    },

    // async  getfileImage(tempProject , projects = null) {
    //   /*process.env.VUE_APP_BASE_AMF_URL + "getfile/decoimage/" + tempProject.decoimage_id + "/500*300/1.4:1",*/
    //   // console.log('TMP:', tempProject);
    //   await fetch(
    //     process.env.VUE_APP_GET_METHOD_URL + "deco&projectid=" + tempProject.projectid + "&id=" + tempProject.decoimage + `&token=` + localStorage.sessiontoken,
    //     {
    //       headers: {
    //         apitoken: localStorage.apikey,
    //         deviceid: localStorage.deviceid,
    //       }
    //     }
    //   )
    //     .then(r => r.blob())
    //     .then(d => {
    //       if(d.size)
    //       {
    //         tempProject.src = this.images[tempProject.id]
    //           = window.URL.createObjectURL(d);
    //       }
    //     });
    // },

    // async  getProjectFile(tempProject , projects = []) {
    //   await fetch(
    //     //process.env.VUE_APP_BASE_AMF_URL + "getfile/decoimage/" + tempProject.decoimage + "/250*150",
    //     process.env.VUE_APP_GET_METHOD_URL + "deco&projectid=" + tempProject.projectid + "&id=" + tempProject.decoimage + `&token=` + localStorage.sessiontoken,
    //     {
    //       headers: {
    //         apitoken: localStorage.apikey,
    //         deviceid: localStorage.deviceid,
    //       }
    //     }
    //   )
    //     .then(r => r.blob())
    //     .then(d => {
    //       if(d.size)
    //       {
    //         tempProject.src = this.images[tempProject.id]
    //           = window.URL.createObjectURL(d);
    //       }
    //     });
    // },

    async getfevProject () {
      if (this.$store.state.projects.projects.length > 1) {
        this.projects = this.$store.state.projects.projects
        this.favourites = this.$store.state.projects.favourites
        $('.spinner-cover').hide()
        return 0
      }

      let params = new URLSearchParams()
      let obj = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `user/getprojectfav`, params, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string',
            accept: 'application/json'
          }
        }).then(response => {
          this.favourites = response.data.data.favourites
          this.$store.commit('setfavourites', this.favourites)
          this.getProject()
        })
        .catch(e => {
          console.log(e)
          obj.errors.push(e)
        })
    },

    loadMore () {
      const _this = this;
      this.loading = true
      if (this.activeprojects.length > this.projectsToShow) {
          this.projectsToShow += 12;
        } else {
          this.btnMore = this.loading = false
        }
      setTimeout(function () {
        _this.loading = false
      }, 3000)

      // const start_num = this.count
      // const end_num = this.count + 8
      // const projects = this.activeprojects
      // const slice = projects.slice(start_num, end_num)
      // if (projects.length >= this.projectsToShow) {
      //   // slice.forEach((item) => {
      //   //   this.getfileImage(item)
      //   // });
      //   this.projectsToShow += this.projectsPerView
      // } else {
      //   this.btnMore = false
      // }
      // this.count = +end_num
      // const _this = this
      // setTimeout(function () {
      //   _this.loading = false
      // }, 1200)
    },

    getCustomerList () {
      // var params = new URLSearchParams()
      // params.append("api_token", localStorage.token);
      let params = {
        "methodName": "getProjectAuthorizations",
        "parameters": [],
        "serviceName": "ProjectdocuService"
      }
      axios.post(`${process.env.VUE_APP_BASE_AMF_URL}/authorities/customerlist&token=${localStorage.sessiontoken}`,
          params,
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
            }
          }
        )
        .then(response => {
          this.customerCreateProject = response.data.customer
          this.customerTestProject = response.data.test[0]
          // this.customerAdmin = response.data.data.customerAdmin
          // localStorage.user = response.data.data.user;
        })
        .catch(e => {
          console.log(e)

          // this.errors.push(e);
        })
    },

    async createProject () {
      $('#exampleModalCenter3').modal('toggle');
      let loading = $('.spinner-cover');
      loading.show();
      let _this = this
      _this.submitted = true
      _this.$v.$touch();
      if (_this.$v.$invalid) {
        return
      }
      let project = this.project
      project.startdate = todayDate();
      let user_id = _this.user.pduserid || localStorage.user_id
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          'methodName': 'createProject',
          'parameters': [ user_id, project ],
          'serviceName': 'ProjectdocuService'
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        if (res.status === 200 || res.statusText === 'OK'){
          _this.$toast.success('Projekt erfolgreich erstellt',res.data[0].projectid)
          document.getElementById("project_form").reset();
          _this.$router.push({ name: 'AppSetting', params: { id: res.data[0].projectid }});
        }
      }).catch(error => {
        _this.$toast.error('Ups! Irgendwas lief schief')
      })
      loading.hide();
    },

    setFavProject (id) {
      if (!this.disabled) {
        this.disabled = true
        axios.get(process.env.VUE_APP_BASE_AMF_URL + (`user/addprojectfav/` + id), {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'
              // Cookie: "PHPSESSID=2l42t252mrldhth20gjq1nhjvn"
            }
          })
          .then(response => {
            this.disabled = false
            if (response.status == 200) {
              this.msg.push(response.data.status)
              this.projects = this.projects.map(projects => {
                if (id == projects.id) {
                  projects.isfav = 1
                }
                return projects
              })
              // this.getfevProject();
            }
          })
          .catch(e => {
            this.disabled = false
            console.log(e)
            this.error.push(e)
          })
      }
    },

    delFavProject (id) {
      if (!this.disabled) {
        this.disabled = true
        axios
          .get(process.env.VUE_APP_BASE_AMF_URL + (`user/delprojectfav/` + id), {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid,
              accept: 'application/json'

            // Cookie: "PHPSESSID=2l42t252mrldhth20gjq1nhjvn"
            }
          })
          .then(response => {
            this.disabled = false

            if (response.status == 200) {
              this.msg.push(response.data.status)
              this.projects = this.projects.map(projects => {
                if (id == projects.id) {
                  projects.isfav = 0
                }
                return projects
              })
            // this.getfevProject();
            }
          })
          .catch(e => {
            this.disabled = false
            console.log(e)
            this.error.push(e)
          })
      }
    },

    openTab (dataName) {
      this.tabA = this.tabB = this.tabC = 0
      if (dataName == 'DataA') this.tabA = 1
      if (dataName == 'DataB') this.tabB = 1
      if (dataName == 'DataC') this.tabC = 1
      let i
      let x = document.getElementsByClassName('d1')
      for (i = 0; i < x.length; i++) {
        x[i].style.display = 'none'
      }
      document.getElementById(dataName).style.display = 'block'
    },

    redirectToPlan (pid) {
      this.$router.push({name: 'Plan', params: {id: pid}})
    },

    redirectToPhotos (project) {
      const pid = project.projectid
      this.$store.commit('setCurrentProject', project)
      this.$router.push({path: `/project/${pid}/photos`})
    },
  },
  computed: {
    filteredList () {
      return this.$store.state.projects.activeprojects.filter(projects => projects.name.toLowerCase().includes(this.$store.state.projects.search.toLowerCase()))
    },
    filteredArchiveList () {
      return this.archiveprojects.filter(projects => projects.name.toLowerCase().includes(this.$store.state.projects.search.toLowerCase()));
    },
    project () {
      return this.$store.state.projects.newProject
    },
    user () {
      return this.$store.state.projects.user
    }
  },
  watch: {
    modal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    msg: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    emodal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    error: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    }
  }
}

</script>
<style scoped>
.custom-control-label::before, .custom-control-label::after{
  top: 3px;
}
@media (max-width: 1100px){
  .main-content1 {
    padding-inline: 55px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projects/index.vue